
import React, { useState } from 'react';

import moment from 'moment';
import {
  InputNumber,
  Row,
  Col,
  Button,
  Checkbox,
  notification,
  Switch,
  DatePicker,
} from 'antd/lib';
import * as Icons from '@ant-design/icons';
import { Form } from '@ant-design/compatible';

import FormVentaSello from '../../formularios/FormVentaSello';
import CustomInput from '../../common/formitems/input';

import _ from 'lodash';

// import SelectorModelo from './SelectorModelo'
const FormItem = Form.Item;

const FormAutorizacionTrabajoMenor = props => {
  const [existeVenta, setExisteVenta] = useState(false);
  const [cantidad_dias, setCantidadDias] = useState(1);
  const [fechaInicial, setFechaInicial] = useState(moment());
  // eslint-disable-next-line no-unused-vars
  const [fechaFinal, setFechaFinal] = useState(moment().add(1, 'days'));
  const [opcionFinal, setOpcionFinal] = useState(false);
  const [telefonos, setTelefonos] = useState('');

  // Extract phone numbers from personas
  const getPersonasTelefonos = () => {
    if (!props.personas || !Array.isArray(props.personas)) {
      return '';
    }
    
    return props.personas
      .filter(persona => 
        persona.telefono && 
        persona.telefono.trim() !== '' && 
        persona.rol !== 'AUTORIZADO'
      )
      .map(persona => persona.telefono.trim())
      .join(', ');
  };

  const handleSubmit = async e => {
    e.preventDefault();
    props.form.validateFieldsAndScroll(
      [
        'numero_acta_nacimiento',
        'existeVenta',
        'mailsNotificar',
        'telefonos',
        'domicilioActividad'
      ],
      async (err, values) => {
        console.log("values  ", values)
        if (err) {
          notification.error({
            message: 'Error',
            description: 'Existe un error en la creacion de la autorizacion.',
          });
        } else {
          // Validate fecha inicial <= fecha final
          if (values.desde && values.hasta && moment(values.desde).isAfter(moment(values.hasta))) {
            notification.error({
              message: 'Error',
              description: 'La fecha inicial no puede ser mayor que la fecha final.',
            });
            return;
          }
          if (values.desde && values.hasta && moment(values.hasta).isBefore(moment(values.desde))) {
            notification.error({
              message: 'Error',
              description: 'La fecha final no puede ser menor que la fecha inicial.',
            });
            return;
          }
          if (values.cantidad_dias > 365) {
            notification.error({
              message: 'Error',
              description: 'La autorizacion no puede superar los 365 dias.',
            });
          } else {
            props.onSubmit({
              numero_acta_nacimiento: values.numero_acta_nacimiento,
              cantidad_dias: values.cantidad_dias,
              domicilioActividad: values.domicilioActividad,
              existeVenta: existeVenta,
              desde: values.desde,
              hasta: values.hasta,
              mailsNotificar: values.mailsNotificar,
              telefonos: values.telefonos
            });
          }
        }
      }
    );
  };

  const changeFechaInicial = valor => {
    let fechaInicial = valor;
    if (valor) {
      let nuevaCantidadDias = _.round(
        moment(props.form.getFieldValue('hasta')).diff(
          fechaInicial,
          'days',
          true
        )
      );
      props.form.setFieldsValue({
        cantidad_dias: nuevaCantidadDias + 1, //El Mas 1 viene dado porque es el dia INCLUSIVE
      });
      setFechaInicial(fechaInicial);
    } else {
      props.form.setFieldsValue({
        cantidad_dias: 0,
        desde: moment(),
      });
      setFechaInicial(fechaInicial);
    }
  };

  const changeFechaFinal = valor => {
    let fechaFin = valor;
    if (valor) {
      let nuevaCantidadDias = _.round(
        moment(fechaFin).diff(props.form.getFieldValue('desde'), 'days', true)
      );

      props.form.setFieldsValue({
        cantidad_dias: nuevaCantidadDias + 1, //El Mas 1 viene dado porque es el dia INCLUSIVE
      });
      setFechaFinal(fechaFin);
    } else {
      props.form.setFieldsValue({
        cantidad_dias: 0,
      });
      setFechaFinal(fechaFin);
    }
  };

  const changeCantidadDias = valor => {
    let cantDias = valor - 1; //El menos 1 viene dado porque es el dia INCLUSIVE
    let nuevaFechaFin = moment(props.form.getFieldValue('desde')).add(
      cantDias,
      'days'
    );
    props.form.setFieldsValue({
      hasta: nuevaFechaFin,
    });
    setCantidadDias(cantDias);
  };

  const onFinalizar = (ventaSinStock, detalles, datosPonset, extras) => {
    // console.log('ENTRE');

    const desde = props.form.getFieldValue('desde');
    const hasta = props.form.getFieldValue('hasta');
    
    // Validate fecha inicial <= fecha final
    if (desde && hasta && moment(desde).isAfter(moment(hasta))) {
      notification.error({
        message: 'Error',
        description: 'La fecha inicial no puede ser mayor que la fecha final.',
      });
      return;
    }
    if (desde && hasta && moment(hasta).isBefore(moment(desde))) {
      notification.error({
        message: 'Error',
        description: 'La fecha final no puede ser menor que la fecha inicial.',
      });
      return;
    }

    if (props.form.getFieldValue('cantidad_dias') > 365) {
      notification.error({
        message: 'Error',
        description: 'La autorizacion no puede superar los 365 dias.',
      });
    } else {
      let datos = {
        numero_acta_nacimiento: props.form.getFieldValue(
          'numero_acta_nacimiento'
        ),
        cantidad_dias: props.form.getFieldValue('cantidad_dias'),
        domicilioActividad: props.form.getFieldValue('domicilioActividad'),
        desde: props.form.getFieldValue('desde'),
        hasta: props.form.getFieldValue('hasta'),
        mailsNotificar: props.form.getFieldValue('mailsNotificar'),
        telefonos: props.form.getFieldValue('telefonos'),
        existeVenta: existeVenta,
        detalles,
        datosPonset,
        extras,
      };
      // console.log('DATOS: ', datos);

      props.onSubmit(datos, ventaSinStock);
    }
  };

  const onFinalizarMP = (ventaSinStock, detalles, datosMP, extras) => {
    // console.log('ENTRE');
    
    const desde = props.form.getFieldValue('desde');
    const hasta = props.form.getFieldValue('hasta');
    
    // Validate fecha inicial <= fecha final
    if (desde && hasta && moment(desde).isAfter(moment(hasta))) {
      notification.error({
        message: 'Error',
        description: 'La fecha inicial no puede ser mayor que la fecha final.',
      });
      return;
    }
    if (desde && hasta && moment(hasta).isBefore(moment(desde))) {
      notification.error({
        message: 'Error',
        description: 'La fecha final no puede ser menor que la fecha inicial.',
      });
      return;
    }

    if (props.form.getFieldValue('cantidad_dias') > 365) {
      notification.error({
        message: 'Error',
        description: 'La autorizacion no puede superar los 365 dias.',
      });
    } else {
      const datos = {
        numero_acta_nacimiento: props.form.getFieldValue(
          'numero_acta_nacimiento'
        ),
        cantidad_dias: props.form.getFieldValue('cantidad_dias'),
        domicilioActividad: props.form.getFieldValue('domicilioActividad'),
        desde: props.form.getFieldValue('desde'),
        hasta: props.form.getFieldValue('hasta'),
        mailsNotificar: props.form.getFieldValue('mailsNotificar'),
        telefonos: props.form.getFieldValue('telefonos'),
        existeVenta: existeVenta,
        detalles,
        datosMP,
        extras,
      };
      props.onSubmit(datos, ventaSinStock);
    }
  };

  const tailFormItemLayout = {
    wrapperCol: {
      xs: {
        span: 24,
        offset: 0,
      },
      sm: {
        span: 16,
        offset: 8,
      },
    },
  };

  return (
    <div>
      <h1 className="tituloForm">Datos de la Autorizacion de Trabajo Adolescente</h1>

  <Form onSubmit={handleSubmit} layout="vertical">
        <Row>
          <CustomInput
            tooltip={'Numero de acta de nacimiento'}
            type={'input'}
            name={'numero_acta_nacimiento'}
            form={props.form}
            label={'Numero del acta de nacimiento'}
            required={true}
            initialValue={_.get(props, 'datos.numero_acta_nacimiento', '')}
            message={'Por favor, ingrese el numero de acta de nacimiento'}
            offset={2}
            span={16}
            placeholder={'Ingresar el numero del acta de nacimiento'}
          />
        </Row>
        <Row>
          <CustomInput
            tooltip={'Domicilio donde trabajara el Menor'}
            type={'input'}
            name={'domicilioActividad'}
            form={props.form}
            label={'Domicilio Actividad'}
            required={true}
            initialValue={_.get(props, 'datos.domicilioActividad', '')}
            message={'Por favor, ingrese el domicilio donde trabajara el Menor'}
            offset={2}
            span={16}
            placeholder={'Calle 123'}
          />
        </Row>
        <Row>
          <CustomInput
            tooltip={'Email de los padres separados por comas ",". \n El mail copreti@neuquen.gov.ar siempre sera notificado'}
            type={'input'}
            name={'mailsNotificar'}
            form={props.form}
            label={'Mails a notificar'}
            required={false}
            message={'Por favor, ingrese un email a notificar'}
            offset={2}
            span={16}
            placeholder={'mail1@mail.com, mail2@mail.com'}
          />
        </Row>
        <Row>
          <CustomInput
            tooltip={'Telefonos de los padres separados por comas ",".'}
            type={'input'}
            name={'telefonos'}
            form={props.form}
            label={'Telefonos a notificar'}
            required={false}
            initialValue={getPersonasTelefonos()}
            message={'Por favor, ingrese un telefono a notificar'}
            offset={2}
            span={16}
            placeholder={'2995123456, 2995654321, etc.'}
          />
        </Row>

        <Row>
          {props.config.creacion && (
            <Col offset={2}>
              <FormItem>
                <Checkbox onChange={e => setExisteVenta(e.target.checked)}>
                  Computar Venta
                </Checkbox>
              </FormItem>
            </Col>
          )}
        </Row>

        {existeVenta && (
          <div>
            <hr />
            <FormVentaSello
              opcionRender={1}
              organismo={props.organismo}
              onFinalizar={(detalles, datosPonset, extras) =>
                onFinalizar(false, detalles, datosPonset, extras)
              }
              crearVentaCompleta={(detalles, datosPonset, extras) =>
                onFinalizar(true, detalles, datosPonset, extras)
              }
              crearVentaMercadoPago={(detalles, datosMP, extras) =>
                onFinalizarMP(true, detalles, datosMP, extras)
              }
              isTramiteAutorizacion={true}
              tramite={'AUTORIZACIONES MENORES'}
            />
            <hr />
          </div>
        )}

        <FormItem {...tailFormItemLayout}>
          <Button type="primary" htmlType="submit" disabled={existeVenta}>
            <Icons.SolutionOutlined />
            Exento
          </Button>
        </FormItem>
      </Form>
    </div>
  );
};

export default Form.create({})(FormAutorizacionTrabajoMenor);
